export default __webpack_public_path__ + "static/media/plantPots.49b42972.jpg";